/**
 * @flow
 */

/**
 * Search suppliers that match specified query
 *
 * @param {String} query - The query to search for
 */
export const search = (query: string) => ({
    type: 'SUPPLIERS.SEARCH',
    query,
});
